import React from 'react';
import Menubar from '../../components/Menubar';
import './Csshome.css';
import './Mobilecsshome.css';
import Play from './play.svg';
import Footer from '../../components/Footer.js';
import Htmlcard from '../../assets/HTML basics card.svg';
import Javascriptcard from '../../assets/Javascript basics card.svg';
import { Link } from 'react-router-dom';


const Csshome = () => {
    return (
      <div className='Htmlpagecontainer'>
        <div className='men'>
          <Menubar />
      </div>

        <div className='csshero' id='csshero'>
        <div className='coursehero'>
            <div className='title'>
                <h1>CSS Basics</h1>
                <p>CSS is used to make website visually appealing hence improves user interface.</p>
            </div>
            <div className='titleintro'>
                <p>Difficulty level: Beginner</p>
                <p>Prerequisites : Learn HTML before learning CSS.</p>
            </div>
        </div>
        </div>

        <div className='takeaway'>
            <h3>Take Away Skills</h3>
            <ul>
                <li>You’ll learn the foundational skill to build web pages.</li>
                <li>You’ll learn to style text, images, tables, lists and forms in your web pages.</li>
                <li>You’ll be develop understanding about building simple website features.</li>
            </ul>
        </div>

        <div className='whatyoulearn'>
            <h3>What You’ll Learn</h3>
            <div className='module'>
                <h4>Module 1 : Get Started</h4>
                <p>In this module you will get foundational understanding about what Css is and how to use it.</p>
                <div className='lessongrid'>
                    <div className='seq'>
                        <p>1</p>
                        <p>What is CSS?</p>
                        <Link to = "/csslesson"><img src={Play} /></Link>
                    </div>
                    <div className='seq'>
                        <p>2</p>
                        <p>CSS Demo</p>
                        <Link to = "/csslesson"><img src={Play} /></Link>
                    </div>
                    <div className='seq'>
                        <p>3</p>
                        <p>Syntax</p>
                        <Link to = "/csslesson"><img src={Play} /></Link>
                    </div>
                    <div className='seq'>
                        <p>4</p>
                        <p>Add CSS to web page : Inline</p>
                        <Link to = "/csslesson"><img src={Play} /></Link>
                    </div>
                    <div className='seq'>
                        <p>5</p>
                        <p>Add CSS to web page : Internal</p>
                        <Link to = "/csslesson"><img src={Play} /></Link>
                    </div>
                    <div className='seq'>
                        <p>6</p>
                        <p>Add CSS to web page : External</p>
                        <Link to = "/csslesson"><img src={Play} /></Link>
                    </div>
                </div>
            </div>
            <div className='module'>
                <h4>Module 2 : Selectors & Styling</h4>
                <p>Learn how to select elements. Apply some styles to them.</p>
                <div className='lessongrid'>
                    <div className='seq'>
                        <p>1</p>
                        <p>Type selector</p>
                        <Link to = "/csslesson"><img src={Play} /></Link>
                    </div>
                    <div className='seq'>
                        <p>2</p>
                        <p>ID selector</p>
                        <Link to = "/csslesson"><img src={Play} /></Link>
                    </div>
                    <div className='seq'>
                        <p>3</p>
                        <p>Class selector</p>
                        <Link to = "/csslesson"><img src={Play} /></Link>
                    </div>
                    <div className='seq'>
                        <p>4</p>
                        <p>Grouping selectors</p>
                        <Link to = "/csslesson"><img src={Play} /></Link>
                    </div>
                    <div className='seq'>
                        <p>5</p>
                        <p>Attribute selector</p>
                        <Link to = "/csslesson"><img src={Play} /></Link>
                    </div>
                    <div className='seq'>
                        <p>6</p>
                        <p>Color</p>
                        <Link to = "/csslesson"><img src={Play} /></Link>
                    </div>
                    <div className='seq'>
                        <p>7</p>
                        <p>Letter Spacing & Line Height</p>
                        <Link to = "/csslesson"><img src={Play} /></Link>
                    </div>
                    <div className='seq'>
                        <p>8</p>
                        <p>text-decoration</p>
                        <Link to = "/csslesson"><img src={Play} /></Link>
                    </div>
                    <div className='seq'>
                        <p>9</p>
                        <p>font-family</p>
                        <Link to = "/csslesson"><img src={Play} /></Link>
                    </div>
                    <div className='seq'>
                        <p>10</p>
                        <p>font stack</p>
                        <Link to = "/csslesson"><img src={Play} /></Link>
                    </div>
                    <div className='seq'>
                        <p>11</p>
                        <p>font-size</p>
                        <Link to = "/csslesson"><img src={Play} /></Link>
                    </div>
                    <div className='seq'>
                        <p>12</p>
                        <p>font-weight</p>
                        <Link to = "/csslesson"><img src={Play} /></Link>
                    </div>
                    <div className='seq'>
                        <p>13</p>
                        <p>Google Fonts</p>
                        <Link to = "/csslesson"><img src={Play} /></Link>
                    </div>
                    <div className='seq'>
                        <p>14</p>
                        <p>Comments</p>
                        <Link to = "/csslesson"><img src={Play} /></Link>
                    </div>
                    <div className='seq'>
                        <p>15</p>
                        <p>Background color</p>
                        <Link to = "/csslesson"><img src={Play} /></Link>
                    </div>
                    <div className='seq'>
                        <p>16</p>
                        <p>Border color</p>
                        <Link to = "/csslesson"><img src={Play} /></Link>
                    </div>
                    <div className='seq'>
                        <p>17</p>
                        <p>Color value</p>
                        <Link to = "/csslesson"><img src={Play} /></Link>
                    </div>
                </div>
            </div>
            <div className='module'>
                <h4>Module 3 : Diving Deeper</h4>
                <p>This module will help in understanding the intricacies of rules. And some more rules.</p>
                <div className='lessongrid'>
                    <div className='seq'>
                        <p>1</p>
                        <p> Default Browser Styles</p>
                        <Link to = "/csslesson"><img src={Play} /></Link>
                    </div>
                    <div className='seq'>
                        <p>2</p>
                        <p>Inheritance</p>
                        <Link to = "/csslesson"><img src={Play} /></Link>
                    </div>
                    <div className='seq'>
                        <p>3</p>
                        <p>Specificity</p>
                        <Link to = "/csslesson"><img src={Play} /></Link>
                    </div>
                    <div className='seq'>
                        <p>4</p>
                        <p>Calculatng Specificity</p>
                        <Link to = "/csslesson"><img src={Play} /></Link>
                    </div>
                    <div className='seq'>
                        <p>5</p>
                        <p>The Cascade</p>
                        <Link to = "/csslesson"><img src={Play} /></Link>
                    </div>
                    <div className='seq'>
                        <p>6</p>
                        <p>Selecting nested elements</p>
                        <Link to = "/csslesson"><img src={Play} /></Link>
                    </div>
                    <div className='seq'>
                        <p>7</p>
                        <p>Background Image</p>
                        <Link to = "/csslesson"><img src={Play} /></Link>
                    </div>
                    <div className='seq'>
                        <p>8</p>
                        <p>Linear Gradients</p>
                        <Link to = "/csslesson"><img src={Play} /></Link>
                    </div>
                </div>
            </div>
            <div className='module'>
                <h4>Module 4 : Building Layouts</h4>
                <p>Learn about HTML element types, building layout and positioning an element</p>
                <div className='lessongrid'>
                    <div className='seq'>
                        <p>1</p>
                        <p> Block elements</p>
                        <Link to = "/csslesson"><img src={Play} /></Link>
                    </div>
                    <div className='seq'>
                        <p>2</p>
                        <p>Inline elements</p>
                        <Link to = "/csslesson"><img src={Play} /></Link>
                    </div>
                    <div className='seq'>
                        <p>3</p>
                        <p>Box Model</p>
                        <Link to = "/csslesson"><img src={Play} /></Link>
                    </div>
                    <div className='seq'>
                        <p>4</p>
                        <p>Padding</p>
                        <Link to = "/csslesson"><img src={Play} /></Link>
                    </div>
                    <div className='seq'>
                        <p>5</p>
                        <p>Border</p>
                        <Link to = "/csslesson"><img src={Play} /></Link>
                    </div>
                    <div className='seq'>
                        <p>6</p>
                        <p>Margin</p>
                        <Link to = "/csslesson"><img src={Play} /></Link>
                    </div>
                    <div className='seq'>
                        <p>7</p>
                        <p>Position : static </p>
                        <Link to = "/csslesson"><img src={Play} /></Link>
                    </div>
                    <div className='seq'>
                        <p>8</p>
                        <p>Position : relative</p>
                        <Link to = "/csslesson"><img src={Play} /></Link>
                    </div>
                    <div className='seq'>
                        <p>9</p>
                        <p>Position : fixed</p>
                        <Link to = "/csslesson"><img src={Play} /></Link>
                    </div>
                    <div className='seq'>
                        <p>10</p>
                        <p>Position : absolute</p>
                        <Link to = "/csslesson"><img src={Play} /></Link>
                    </div>
                </div>
            </div>
        </div>


        <div className='whatnext'>
            <h3>What Next</h3>
            
            <div className='whatnextgrid'>
                <div className='whatnextcol'>
                    <p>1</p>
                    <Link to = "/html"><img src={Htmlcard} /></Link>
                </div>
                <div className='whatnextcol'>
                    <p>2</p>
                    <Link to = "/js"><img src={Javascriptcard} /></Link>
                </div>
            </div>       
        </div>

        <div className='faq'>
        <h1>Frequently Asked Questions</h1>
        <div className='faqgrid'>
          <div className='faqcol'>
            <p>Q. Why should I learn CSS?</p>
            <p>A. CSS is another foundational pillar used in building a web page or web application.</p>
          </div>
          <div className='faqcol'>
            <p>Q. Is hard to learn CSS?</p>
            <p>A. CSS is a bit tricky. With practice you can master it.</p>
          </div>
          <div className='faqcol'>
            <p>Q. What is the recommended way to learn CSS?</p>
            <p>A. Read lessons and code along. Read the CSS 
            documentation. Build some website features and practice a lot. </p>
          </div>
        </div>
      </div>

      <Footer />

      </div>
      
    );
  };
  
  export default Csshome;